// src/components/charts/MoneyCharts.js — SAME FONT WEIGHT
import React, { useEffect, useState } from "react";
import { client } from "../../sanityClient";
import { formatDateBS } from "../../utils/dateUtils";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    CartesianGrid,
} from "recharts";
import "./ChartContainer.css";

export default function MoneyCharts() {
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        const fetchChartData = async () => {
            try {
                const data = await client.fetch(`
          *[_type == "moneyTransaction"]{
            givenOrTaken,
            amount,
            date
          }
        `);

                const grouped = {};
                data.forEach((t) => {
                    const dateObj = new Date(t.date);
                    const year = dateObj.getFullYear();
                    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                    const day = String(dateObj.getDate()).padStart(2, '0');
                    const d = `${year}-${month}-${day}`;
                    if (!grouped[d]) grouped[d] = { date: d, Debit: 0, Credit: 0 };
                    if (t.givenOrTaken === "Debit")
                        grouped[d].Debit += parseFloat(t.amount) || 0;
                    else if (t.givenOrTaken === "Credit")
                        grouped[d].Credit += parseFloat(t.amount) || 0;
                });

                const formatted = Object.values(grouped).sort(
                    (a, b) => new Date(a.date) - new Date(b.date)
                );
                setChartData(formatted);
            } catch (err) {
                console.error("Error fetching money chart data:", err);
            }
        };

        fetchChartData();
    }, []);

    return (
        <div className="chart-container">
            <h6 className="chart-title-center">Money Flow Over Time</h6>
            <div style={{ width: "100%", height: 260 }}>
                <ResponsiveContainer>
                    <LineChart
                        data={chartData}
                        margin={{ top: 5, right: 20, left: 20, bottom: 40 }}
                    >
                        <CartesianGrid strokeDasharray="5 5" stroke="#e0e0e0" />
                        <XAxis
                            dataKey="date"
                            tick={{ fontSize: 12, fill: "#065f46", fontWeight: 600 }}
                            angle={-45}
                            textAnchor="end"
                            height={70}
                            tickFormatter={(value) => formatDateBS(value)}
                        />
                        <YAxis
                            tick={{ fontSize: 12, fill: "#065f46", fontWeight: 600 }}
                            tickFormatter={(value) => `₹${value.toLocaleString()}`}
                            width={70}
                        />
                        <Tooltip
                            contentStyle={{
                                background: "#fff",
                                border: "2px solid #34d399",
                                borderRadius: "12px",
                                padding: "10px",
                                fontSize: "13px"
                            }}
                            labelStyle={{ color: "#065f46", fontWeight: 800 }}
                            itemStyle={{ fontWeight: 600 }}
                            labelFormatter={(value) => formatDateBS(value)}
                        />
                        <Legend
                            verticalAlign="top"
                            height={32}
                            wrapperStyle={{ top: 0, fontWeight: 700 }}
                        />
                        <Line
                            type="monotone"
                            dataKey="Debit"
                            stroke="#dc2626"
                            strokeWidth={2}
                            dot={{ r: 4 }}
                            activeDot={{ r: 6 }}
                            name="Debit"
                        />
                        <Line
                            type="monotone"
                            dataKey="Credit"
                            stroke="#059669"
                            strokeWidth={2}
                            dot={{ r: 4 }}
                            activeDot={{ r: 6 }}
                            name="Credit"
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}